import { isAltTextFeatureEnabled } from '~/utils/altTextFeature'

/**
 * Shared alt resolution for CMS media.
 * Priority: media alternativeText (flat or attributes), then caller fallbacks
 * (entity title, page title from usePageAltFallback, static default) when
 * `NUXT_PUBLIC_ALT_TEXT_ENABLED` is `true`.
 */

function asAltString (value: unknown): string {
  if (typeof value !== 'string') return ''
  return value.trim()
}

export function firstMeaningfulAlt (...candidates: unknown[]): string {
  for (const candidate of candidates) {
    const text = asAltString(candidate)
    if (text) return text
  }
  return ''
}

export function mediaAltText (image?: {
  alternativeText?: unknown
  attributes?: { alternativeText?: unknown }
  data?: { attributes?: { alternativeText?: unknown } }
} | null): string {
  if (!image || typeof image !== 'object') return ''

  return firstMeaningfulAlt(
    image.alternativeText,
    image.attributes?.alternativeText,
    image.data?.attributes?.alternativeText
  )
}

export function resolveMediaAlt (
  image: Parameters<typeof mediaAltText>[0],
  ...fallbacks: unknown[]
): string {
  const cmsAlt = mediaAltText(image)
  if (cmsAlt) return cmsAlt
  if (!isAltTextFeatureEnabled()) return ''
  return firstMeaningfulAlt(...fallbacks)
}
